import React, { useContext, useState } from 'react'
import {
  ModalBody,
  ModalFooterInForm,
  ModalHeader,
  ModalWrapper,
} from '~/components/common/Modal'
import { ChatContext } from '~/service/chatConn'
import { MiddlewareCommand } from '~/service/chatConn/types'
import { Controller, useForm } from 'react-hook-form'
import { TextField } from '~/components/common/Form'
import { notify } from '~/utils/notify'
import trans from '~/translations/trans'

type Props = {
  command: MiddlewareCommand
  close: () => void
}

const MiddlewareCommandModal: React.FC<Props> = ({ command, close }) => {
  const { runMiddlewareCommand } = useContext(ChatContext)

  const {
    handleSubmit,
    control,
    formState: { isSubmitting },
    setError,
  } = useForm<Record<string, any>>({
    defaultValues: command.parameters.reduce(
      (acc, param) => ({
        ...acc,
        [param.name]: '',
      }),
      []
    ),
  })

  return (
    <ModalWrapper>
      <form
        className="modal-card"
        onSubmit={handleSubmit(async data => {
          const resp = await runMiddlewareCommand(command.name, data)

          if (resp.status == 'wrong_params') {
            resp.data.forEach(({ name, reason }) => {
              setError(name, { message: reason })
            })
          } else {
            notify(resp.data.message, 'success')

            close()
          }
        })}
      >
        <ModalHeader title={command.description} onClose={close} />
        <ModalBody>
          {command.parameters.map(param => (
            <Controller
              key={param.name}
              name={param.name}
              control={control}
              render={renderProps => (
                <TextField
                  label={param.description}
                  renderProps={renderProps}
                  horizontal={false}
                />
              )}
              rules={{
                required: param.required ? trans.valid.required() : undefined,
              }}
            />
          ))}
        </ModalBody>
        <ModalFooterInForm onCancel={close} isSubmitting={isSubmitting} />
      </form>
    </ModalWrapper>
  )
}

export default MiddlewareCommandModal
